import { render, staticRenderFns } from "./devedores.vue?vue&type=template&id=971cad74&"
import script from "./devedores.vue?vue&type=script&lang=js&"
export * from "./devedores.vue?vue&type=script&lang=js&"
import style0 from "./devedores.vue?vue&type=style&index=0&id=971cad74&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports